module.exports = __webpack_public_path__ + "img/very-helpful-unscreen.ab69ef15.gif";